// src/IframeHost.js
import React, { useState, useEffect, useRef } from "react";

function IframeHost() {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const iframeRef = useRef(null);
  const [sessionFromUrl, setSessionFromUrl] = useState("");

  useEffect(() => {
    const sessionQueryParams = window.location.search;
    setSessionFromUrl(new URLSearchParams(sessionQueryParams).get("session"));

    console.log("session", sessionFromUrl);

    // ignore
    const handleLoad = () => {
      setIframeLoaded(true);
      console.log("Iframe loaded!");
    };

    const handleMessage = (event) => {
      if (event.origin !== "https://enterprise-uat.socialpilot.co") {
        return;
      }
      console.log("Message received from iframe:", event.data);
      // ... handle the message ...

      // Example response:
      iframeRef.current.contentWindow.postMessage(
        "Response from host",
        `https://enterprise-uat.socialpilot.co/custom-login?session=${sessionFromUrl}`
      );
    };

    if (iframeRef.current) {
      iframeRef.current.addEventListener("load", handleLoad);
      window.addEventListener("message", handleMessage); // Listen for messages
    }

    return () => {
      if (iframeRef.current) {
        iframeRef.current.removeEventListener("load", handleLoad);
      }
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  console.log(
    `https://enterprise-uat.socialpilot.co/custom-login?session=${sessionFromUrl}`
  );
  return (
    <div>
      <h1>My App with an Iframe</h1>
      <iframe
        ref={iframeRef}
        src={`https://enterprise-uat.socialpilot.co/custom-login?session=${sessionFromUrl}`}
        title="Embedded App"
        width="800"
        height="600"
        style={{ border: "1px solid black" }}
      >
        {iframeLoaded ? null : <p>Loading...</p>}
      </iframe>
    </div>
  );
}

export default IframeHost;
